import React from 'react';

import styled from '@emotion/styled';

import {
  BREAKPOINTS,
  disabledColor,
  primaryColor,
  unit,
  unitTRBL,
  white,
} from '@zego/theme';

import CircleBackground from '@zego/components/atoms/CircleBackground';
import H2 from '@zego/components/atoms/H2';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';

const Container = styled(View)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  padding: unitTRBL(8, 1.75, 5, 1.75),
  border: '1px solid',
  borderRadius: 8,
  backgroundColor: white,
  margin: unitTRBL(0, 2),
});

const TileCircleBackground = styled(CircleBackground)({
  margin: '0 auto',
  marginBottom: unit(5),
});

const TileTitle = styled(H2)({
  color: disabledColor(10),
  fontSize: 22,
  fontWeight: 700,
  flex: 1,
  letterSpacing: '-0.5px',
  lineHeight: '28px',
  textAlign: 'center',
  [BREAKPOINTS.small]: {
    fontSize: 22,
  },
});

const TileDescription = styled(RegularText)({
  textAlign: 'center',
  fontSize: 18,
  lineHeight: '24px',
});

export default function CarouselTile({
  image,
  alt,
  title,
  description,
}: {
  image: string;
  alt: string;
  title: string;
  description: string;
}): JSX.Element {
  return (
    <Container>
      <TileCircleBackground size={48} backgroundColor={primaryColor(8)}>
        <img alt={alt} src={image} />
      </TileCircleBackground>
      <Spacer height={unit(2)} />
      <TileTitle>{title}</TileTitle>
      <Spacer height={unit(1)} />
      <pre css={{ margin: 0 }}>
        <TileDescription>{description}</TileDescription>
      </pre>
    </Container>
  );
}
